import { useLazyQuery, useMutation } from '@apollo/client'
import React, { useEffect } from 'react'
import { CallBackProps, LIFECYCLE, STATUS } from 'react-joyride'

import {
  CREATE_USER_TOUR_RECORD,
  CreateUserTourRecordMutation,
  CreateUserTourRecordMutationVariables,
  GET_LOGGED_IN_USER_TOUR_RECORD,
  GetLoggedInUserTourRecordQuery,
  GetLoggedInUserTourRecordQueryVariables,
} from '@/graphql'

type Props = {
  tourName: string
}
export const useTour = (props: Props) => {
  const { tourName } = props
  const [run, setRun] = React.useState(false)
  const [createUserTourRecord] = useMutation<
    CreateUserTourRecordMutation,
    CreateUserTourRecordMutationVariables
  >(CREATE_USER_TOUR_RECORD)
  const [getUserTours, { data, loading }] = useLazyQuery<
    GetLoggedInUserTourRecordQuery,
    GetLoggedInUserTourRecordQueryVariables
  >(GET_LOGGED_IN_USER_TOUR_RECORD, {
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    if (!loading && data && data.loggedInUser) {
      const tourRecord = data.loggedInUser.tourRecords.find(
        record => record.tour.name === tourName,
      )
      if (!tourRecord || (tourRecord.progress === 0 && !tourRecord.skipped)) {
        setRun(true)
      }
    }
  }, [loading, data])

  useEffect(() => {
    getUserTours()
  }, [])

  const handleTourEnd = async (skipped: boolean, progress: number) => {
    setRun(false)
    if (data?.loggedInUser) {
      await createUserTourRecord({
        variables: {
          data: {
            tourName,
            userId: data.loggedInUser.id,
            skipped,
            progress,
          },
        },
      })
    }
  }

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { index, status, size, lifecycle } = data
    const percentComplete = (index + 1) / size
    if (lifecycle === LIFECYCLE.COMPLETE && status === STATUS.FINISHED) {
      handleTourEnd(false, percentComplete)
    }
    if (lifecycle === LIFECYCLE.COMPLETE && status === STATUS.SKIPPED) {
      handleTourEnd(true, percentComplete)
    }
  }

  return {
    run,
    handleJoyrideCallback,
  }
}
